import { Platform } from 'react-native';
import {
    isPurchase,
    isRent,
    isSubscription,
    Product,
    Purchase,
    Rent,
    Subscription,
} from '@24i/nxg-sdk-photon/src';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';

type UseuseExternalAccessValueProps = {
    getExternalAccessValue: (externalAccessValue?: string, platform?: string) => string;
    getOfferId: (selectedItem: Purchase | Rent | Product | Subscription) => string;
};

const getPlatform = () => {
    if (Platform.isTV && Platform.OS === 'ios') return 'tvos';
    return Platform.OS;
};

export const useExternalAccessValue = (): UseuseExternalAccessValueProps => {
    const appstoreProductIDs = useFeature('appstoreProductIDs');
    const getExternalAccessValue = (externalAccessValue, platform = getPlatform()) => {
        if (!appstoreProductIDs || !appstoreProductIDs?.enabled) {
            return externalAccessValue;
        }
        const productData = appstoreProductIDs[externalAccessValue];

        return productData?.[platform] ?? externalAccessValue;
    };

    const getOfferId = (selectedItem: Purchase | Rent | Product | Subscription) => {
        if (isSubscription(selectedItem) || isRent(selectedItem) || isPurchase(selectedItem)) {
            return getExternalAccessValue(selectedItem.externalAccessValue);
        }
        return '';
    };

    return { getExternalAccessValue, getOfferId };
};
